module.exports = __webpack_public_path__ + "static/media/FoodFraud.8668ef28.png";